import { useMemo } from "react";

import { IWebStompWorkerSubscribtionOptions } from "./worker";
import { IMqPermissions } from "./ws.types";

export const SUBSCRIPTION_CONFIG = [
  { alias: "commonWebEvent", path: "common/web-event" },
  { alias: "appBillingAccountUpdated", path: "_app/billing/account:updated" },
  { alias: "appBillingBillPaid", path: "_app/billing/bill:paid" },
  {
    alias: "appBillingRecurringPaymentUpdated",
    path: "_app/billing/recurring-payment:updated",
  },
  {
    alias: "appEasypostActiveFeatureUpdated",
    path: "_app/easypost/active-feature:updated",
  },
  {
    alias: "appEasypostPlanSubscriptionUpdated",
    path: "_app/easypost/plan-subscription:updated",
  },
  { alias: "appEasypostPostUpdated", path: "_app/easypost/post:updated" },
  { alias: "appUsersMeUpdated", path: "_app/users/me:updated" },
  {
    alias: "accountCredentialUpdated",
    path: "account-credentials/account-credential:updated",
  },
  { alias: "pageSubscriptionsUpdated", path: "page/subscriptions:updated" },
  { alias: "streamDestinationUpdated", path: "stream/destination:updated" },
  { alias: "streamSourceUpdated", path: "stream/source:updated" },
  { alias: "streamStreamUpdated", path: "stream/stream:updated" },
  {
    alias: "billingStatusUpdated",
    path: "_app/easypost/billing-status:updated",
  },
  {
    alias: "reportPipelineCreated",
    path: "report/pipeline:created",
  },
  {
    alias: "reportPipelineDeleted",
    path: "report/pipeline:deleted",
  },
  {
    alias: "artGalleryPolotnoCreated",
    path: "art-gallery/polotno:created",
  },
  {
    alias: "artGalleryPolotnoUpdated",
    path: "art-gallery/polotno:updated",
  },
  {
    alias: "artGalleryPolotnoDeleted",
    path: "art-gallery/polotno:deleted",
  },
  {
    alias: "artGalleryUploadCreated",
    path: "art-gallery/upload:created",
  },
  {
    alias: "artGalleryUploadDeleted",
    path: "art-gallery/upload:deleted",
  },
  {
    alias: "repostСonfigСreated",
    path: "repost/repost-config:created",
  },
  {
    alias: "repostСonfigUpdated",
    path: "repost/repost-config:updated",
  },
  {
    alias: "repostСonfigDeleted",
    path: "repost/repost-config:deleted",
  },
  {
    alias: "gptPromptCreated",
    path: "gpt/prompt:created",
  },
  {
    alias: "gptPromptDeleted",
    path: "gpt/prompt:deleted",
  },
  {
    alias: "organizationMembershipDeletedByOwner",
    path: "_app/organization/membership:deleted_by_owner",
  },
  {
    alias: "organizationMembershipDeletedByMember",
    path: "_app/organization/membership:deleted_by_member",
  },
  {
    alias: "organizationMembershipUpdated",
    path: "_app/organization/membership:updated",
  },
  {
    alias: "organizationPropagated",
    path: "_app/organization/organization:propagated",
  },
  {
    alias: "pageConfigCreated",
    path: "_app/easypost/page_config:created",
  },
  {
    alias: "pageConfigUpdated",
    path: "_app/easypost/page_config:updated",
  },
  {
    alias: "pageConfigDeleted",
    path: "_app/easypost/page_config:deleted",
  },
  {
    alias: "socialPageGroupCreated",
    path: "_app/easypost/social_page_group:created",
  },
  {
    alias: "socialPageGroupUpdated",
    path: "_app/easypost/social_page_group:updated",
  },
  {
    alias: "watermarkCreated",
    path: "_app/easypost/watermark:created",
  },
  {
    alias: "watermarkUpdated",
    path: "_app/easypost/watermark:updated",
  },
  {
    alias: "watermarkDeleted",
    path: "_app/easypost/watermark:deleted",
  },
  {
    alias: "uploadUpdated",
    path: "_app/uploads/upload:updated",
  },
  {
    alias: "clientMaxConnectSuccess",
    path: "client-max/connect:success",
  },
  {
    alias: "clientMaxConnectFailure",
    path: "client-max/connect:failure",
  },
] as const;

export const useWsSubscriptions = (permission?: IMqPermissions) =>
  useMemo<IWebStompWorkerSubscribtionOptions[]>(() => {
    if (!permission) {
      return [];
    }

    const { iss, sub, scopes: mqPermissionsMap } = permission;

    return SUBSCRIPTION_CONFIG.reduce<IWebStompWorkerSubscribtionOptions[]>((acc, entry) => {
      const permission = `mq/${entry.path}`;
      const exchange = `/exchange/smp/${entry.path.replace(/\//g, "%2F")}.${iss}.${sub}.#`;

      if (mqPermissionsMap.get(permission)?.includes("r")) {
        acc.push({
          alias: entry.alias,
          path: exchange,
        });
      }

      return acc;
    }, []);
  }, [permission]);
